export function isIE() {
  if (window.document.documentMode) {
    return true;
  }
  return false;
}
